import { useI18n } from '@change-corgi/core/react/i18n';

import { useIsSecureGuest } from 'src/app/shared/hooks/payments';

import { usePromoteFormData, usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		shouldSavePaymentMethod: boolean;
		label: string;
	},
	{ setShouldSavePaymentMethod: (shouldSavePaymentMethod: boolean) => void }
>;

export function useShouldSavePaymentMethodInput(): Result {
	const [
		{
			paymentMethodSaveOptions: { shouldSavePaymentMethod },
			moreWaysExpanded,
		},
		{ setShouldSavePaymentMethod },
	] = usePromoteFormState();

	const {
		featureConfigs: { doubleOptinEnabledNewUser },
	} = usePromoteFormData();
	const isSecureGuest = useIsSecureGuest(doubleOptinEnabledNewUser);

	const { translate } = useI18n();

	return {
		data: {
			displayed: !isSecureGuest && moreWaysExpanded,
			shouldSavePaymentMethod,
			label: translate('corgi.co.promote.save_payment_info'),
		},
		actions: {
			setShouldSavePaymentMethod,
		},
	};
}
